import { useSearch } from '@tanstack/react-router';

import { SubmitStepper } from '@/components/submit-wizard/submit-stepper';
import { SubmitWizardProvider } from '@/components/submit-wizard/submit-wizard-context';
import { WizardForm } from '@/components/submit-wizard/wizard-form';
import { paths } from '@/routes/paths';

export default function SubmitWizard() {
  const { mode } = useSearch({ from: paths.submit });

  return (
    <SubmitWizardProvider mode={mode}>
      <div className="mx-auto flex w-full max-w-[900px] flex-col items-center gap-8">
        <SubmitStepper />
        <WizardForm />
      </div>
    </SubmitWizardProvider>
  );
}
